import { useContext, useEffect, ReactNode } from "react";

import { TabSwitcherContext } from "./TabContext";

export interface ITabPaneProps {
  /**
   * Set tab ID that match `TabLink` id.
   * Also accept an array of ID's (screens) that will trigger this tab to be visible.
   */
  tabDisplayId?: string | string[];
  children?: ReactNode;
}

function TabPane({ tabDisplayId, children }: ITabPaneProps) {
  const context = useContext(TabSwitcherContext);
  /**
   * On mount, push tabId to array of existing tabs
   */
  useEffect(() => {
    context?.createTab && context.createTab(tabDisplayId);

    return () => {
      context?.removeTab && context.removeTab(tabDisplayId);
    };
  }, [context, tabDisplayId]);

  /**
   * Check if tab is visible,
   *  create and array from single string or existing array
   */
  const isTabActive = [].concat(tabDisplayId).includes(context?.activeItem);

  return isTabActive ? (children as any) : null;
}

export default TabPane;
